import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import VenueHeroComponent from './js/venue-hero.component';


ComponentsFactory.getInstance().define('venue-hero', VenueHeroComponent);
